import { ReactNode, useLayoutEffect, useState } from "react"

import CorgiPopup from "./CorgiPopup"
import Page from "./Page"
import PageSpinner from "./PageSpinner"

interface EmptyPageProps {
  title?: string
  children?: ReactNode
}

const EmptyPage = ({
  title = "Hi friend!",
  children = "There doesn't seem to be anything here, but belly rubs are always appreciated!",
}: EmptyPageProps) => {
  const [showPage, setShowPage] = useState(false)
  useLayoutEffect(() => {
    setTimeout(() => {
      setShowPage(true)
    }, 100)
  }, [])

  if (!showPage) {
    return (
      <Page>
        <PageSpinner />
      </Page>
    )
  }

  return (
    <div
      style={{
        background: "linear-gradient(180deg, #f7f5f3 0%, #c6b1a4 100%)",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        paddingTop: 130,
      }}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #ffdbc5 0%, #dfaf66 120%)",
          borderRadius: 20,
          padding: "40px",
          boxShadow: `
          0 8px 32px rgba(0, 0, 0, 0.1),
          0 2px 8px rgba(0, 0, 0, 0.05)
        `,
          border: "1px solid rgba(210, 105, 30, 0.1)",
          maxWidth: "1000px",
          margin: "0 auto",
          height: "fit-content",
        }}
      >
        <CorgiPopup title={title}>{children}</CorgiPopup>
      </div>
    </div>
  )
}

export default EmptyPage
